import { useRef, useState, useEffect } from 'react';
import './icons.scss';

export interface IconProps {
  size?: 'extra-small' | 'small' | 'extra-medium' | 'medium' | 'large';
  fill?: string;
  disabled?: boolean;
  width?: string;
}

type Props = IconProps & { name: string };

// runtime fetch
export const Icon = ({
  name,
  fill,
  disabled,
  size = 'small',
  width,
}: Props): JSX.Element | null => {
  const ImportedIconRef = useRef<any>();
  const [loading, setLoading] = useState(false);

  useEffect((): void => {
    setLoading(true);
    const importIcon = async (): Promise<void> => {
      try {
        ImportedIconRef.current = '';
      } catch (err) {
        // Your own error handling logic, throwing error for the sake of
        // simplicity
        throw err;
      } finally {
        setLoading(false);
      }
    };
    importIcon();
  }, [name]);

  if (!loading && ImportedIconRef.current) {
    const { current: ImportedIcon } = ImportedIconRef;
    return (
      <ImportedIcon
        style={Object.assign(
          { fill: disabled ? 'var(--tru-grey-400)' : fill },
          width && { width: width },
        )}
        className={`tru-icon ${width ? '' : size} ${
          disabled ? 'tru-icon-disabled' : ''
        }`}
      />
    );
  }

  return null;
};
